import { render, staticRenderFns } from "./OrgUploadedDocs.vue?vue&type=template&id=37cbddba&scoped=true"
import script from "./OrgUploadedDocs.vue?vue&type=script&lang=js"
export * from "./OrgUploadedDocs.vue?vue&type=script&lang=js"
import style0 from "./OrgUploadedDocs.vue?vue&type=style&index=0&id=37cbddba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cbddba",
  null
  
)

export default component.exports